var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "man",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#1b2a2d",
    floodOpacity: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)",
    transform: "translate(18 12) scale(0.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 46c-18 0-32 14-32 50v7c0 5 4 9 9 9h46c5 0 9-4 9-9v-7c0-36-14-50-32-50z",
    fill: "#3c78b5",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 108V60",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 108V60",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 28,
    r: 22,
    fill: "#f1c27d",
    stroke: "#263238",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 29c1-17 11-26 24-26 12 0 21 8 21 20 0 3 0 5-1 8-7-10-18-8-27-16-4 8-10 11-17 14z",
    fill: "#2c2c2c",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 3,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 32,
    r: 3,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 43c5 4 11 4 16 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManSingle);
export default __webpack_public_path__ + "static/media/man-single.5eedbfe33350177a7474027dc9467140.svg";
export { ForwardRef as ReactComponent };